<button type="button" class="btn btn-outline-secondary mr-2" placement="left"
		[ngbPopover]="popContent" popoverTitle="Select your local timezone" container="body" [autoClose]="false" triggers="manual" #p="ngbPopover" (click)="p.open()">
	<div class="actualDate">Greece Time: {{this.previewDate}}</div>
	<div class="message">{{yourTime}}</div>
	<small>(Click to change timezone)</small>
</button>
<ng-template #popContent>
	<ng-select [(ngModel)]="timezone"
			   [items]="timeZones"
			   [groupBy]="'group'"
			   [virtualScroll]="true"
			   [clearable]="false"
			   (change)="onSelectChange()"
			   bindLabel="name">
	</ng-select>
	<div class="text-center">
		<button type="button" class="btn btn-sm btn-outline-secondary mr-2" (click)="p.close()">
			Close
		</button>
	</div>
</ng-template>

